module.exports = __webpack_public_path__ + "media/images/noimg-d2e9845d4d78a0fad62766da12a0f8bd.png";